import http from '@/apis/utils/request-plugin';
import { LoginTerminal } from '@/configs/enums/basics';

const baseUrl = '';
const noNeedAuthOptions = { tokenType: 'none' };

/**
 * 刷新权限
 * @param {*} data
 * @returns
 */
const refreshAuthority = (data: { terminal: number }) =>
  http.get(`${baseUrl}/refresh-authority`, data);

/**
 * 判断是否有数据权限
 * @param {*} data
 * @returns
 */
export const checkDataAuth = (data: {
  /**
   * 业务码(必填)

   */
  bizCode?: number;
  /**
   * 操作码 如果不传默认为查询（query）
   */
  operationCode?: string;
}) => http.get(`${baseUrl}/check-data-auth`, data);

/**
 * 退出登录
 * @param {*} data
 * @returns
 */
const logout = (data: any) => http.postPreset(`${baseUrl}/logout`, data);

/**
 * 续签令牌
 * @param {*} data
 * @param {string} data.ticket 票据
 */
const renewToken = (data: {
  /**
   * 票据
   */
  ticket: string;
}) =>
  http.postPreset(`${baseUrl}/renew-token`, data, {
    tokenType: 'none',
    Refreshing: true,
  });

/**
 * 获取登录信息
 *
 * @param data 包含终端类型信息的对象
 * @param data.terminal 终端类型
 * @returns 登录信息
 */
const getLoginInfo = (data: {
  /**
   * 终端类型
   */
  terminal: number;
  /**
   * 当登录信息无效时，不弹出登录提示
   */
  unAlertToLogin?: boolean;
}) => {
  const config = {
    tokenType: 'check',
    customConfig: { unAlertToLogin: false },
  };
  if (data?.unAlertToLogin) {
    config.customConfig.unAlertToLogin = data.unAlertToLogin;
  }
  return http.get(`${baseUrl}/get-login-info`, data, config);
};

/**
 * 获取登录信息
 *
 * @param data 包含终端类型信息的对象
 * @param data.terminal 终端类型
 * @returns 登录信息
 */
export const getLoginInfoWithConfig = (
  data: {
    /**
     * 终端类型
     */
    terminal: number;
  },
  config,
) =>
  http.get(`${baseUrl}/get-login-info`, data, {
    tokenType: 'check',
    ...config,
  });

/**
 * 获取用户令牌
 *
 * @param data 请求参数
 * @param data.ticket 票据
 * @returns 返回获取到的用户令牌
 */
const getUserToken = (data: {
  /**
   * 票据
   */
  ticket: string;
}) =>
  http.postPreset(`${baseUrl}/get-user-token`, data, {
    tokenType: 'check',
  });

/**
 * 登录应用系统
 *
 * @param data 登录应用系统所需的数据
 * @param data.appId 应用系统标识
 * @returns 登录结果
 */
const loginApp = (data: {
  /**
   * 应用系统标识
   */
  appId: string;
}) =>
  http.postJson(`${baseUrl}/login-app`, data, {
    tokenType: 'check',
  });

/* --------------------------------------- 用于移动端登录相关begin ---------------------------------------*/

/**
 * 微信登录
 */
export const weChatLogin = (
  data: {
    /**
     * 应用系统标识
     */
    appId: string;
    /**
     * 授权码
     */
    code: string;
  },
  isSilently: boolean,
) =>
  http.postJson(`${baseUrl}/login/we-chat-applet`, data, {
    ...noNeedAuthOptions,
    isSilently,
    sourceType: 2,
  });

/**
 * 微信登录绑定
 */
export const weChatLoginBind = (data: {
  /**
   * 应用系统标识
   */
  appId: string;
  /**
   * 临时票据
   */
  ticket: string;
  /**
   * 身份证号
   */
  idCard: string;
  /**
   * phone
   */
  phone: string;
  /**
   * code
   */
  code: string;
  /**
   * captchaTicket
   */
  captchaTicket: string;
}) =>
  http.postJson(`${baseUrl}/login/we-chat/bind`, data, {
    ...noNeedAuthOptions,
    isSilently: true,
    sourceType: LoginTerminal.小程序端,
  });

/**
 * 企业微信登录
 */
export const weComLogin = (
  data: {
    /**
     * 应用系统标识
     */
    appId: string;
    /**
     * 授权码
     */
    code: string;
  },
  isSilently: boolean,
) =>
  http.postJson(`${baseUrl}/login/we-com-applet`, data, {
    ...noNeedAuthOptions,
    isSilently,
    sourceType: LoginTerminal.小程序端,
  });

/**
 * 发送验证码-二次认证
 */
export const sendCodeForBind = (
  data: {
    /**
     * 图形验证码票据
     */
    captchaTicket: string;
    /**
     * 二次认证票据
     */
    ticket: string;
  },
  isSilently: boolean,
) =>
  http.postPreset(`${baseUrl}/login/send-code-for-bind-id-card`, data, {
    isSilently,
  });

/**
 * 发送验证码-二次认证
 */
export const secondaryAuthSendCode = (
  data: {
    /**
     * 图形验证码票据
     */
    captchaTicket: string;
    /**
     * 二次认证票据
     */
    ticket: string;
  },
  isSilently: boolean,
) =>
  http.postPreset(`${baseUrl}/secondary-auth/send-code`, data, { isSilently });

/**
 * 检查验证码-二次认证
 */
export const secondaryAuthCheckCode = (
  data: {
    /**
     * 图形验证码票据
     */
    captchaTicket: string;
    /**
     * 二次认证票据
     */
    ticket: string;
    /**
     * 验证码
     */
    code: string;
  },
  isSilently: boolean,
) =>
  http.postPreset(`${baseUrl}/secondary-auth/check-code`, data, {
    isSilently,
    sourceType: LoginTerminal.小程序端,
  });

/* --------------------------------------- 用于移动端登录相关end ---------------------------------------*/

export {
  logout,
  refreshAuthority,
  getLoginInfo,
  getUserToken,
  renewToken,
  loginApp,
};
